import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { IMAGE_HEADER_BASE_CLASSNAME } from './Constants';
import { createImageHeader } from './ImageHeader';
createComponents(".".concat(IMAGE_HEADER_BASE_CLASSNAME), createImageHeader, NO_PATTERN_BUSINESS_LOGIC);
